<div class="panel widget" *ngIf="(expiries && expiries.length > 0) || working">
    <div class="panel-heading-flex">
        <div class="panel-title no-uppercase">
            Organisation Authority Register Expiries (RPA and Personnel)
        </div>
        <div class="panel-content"></div>
        <div class="panel-buttons">
            <button
                class="btn btn-inline"
                (click)="onToggleCollapse()"
                [tooltip]="showBody ? 'Hide' : 'Show'"
                placement="left"
            >
                <i *ngIf="showBody" class="fa-chevron-up fa no-border"></i>
                <i *ngIf="!showBody" class="fa-chevron-down fa no-border"></i>
            </button>
        </div>
    </div>
    <div *ngIf="showBody" class="panel-body" @expandOnEnter @collapseOnLeave>
        <div
            class="static-table-container no-actions"
            *ngIf="expiries && expiries.length"
        >
            <static-table
                [availableColumns]="availableColumns"
                [selectedColumns]="selectedColumns"
                [tableData]="expiries"
                [tableConfig]="tableConfig"
                [borderless]="false"
                [underlinedRows]="true"
                [columnSorting]="tableSorting"
                scanability="comfortable"
                (pageChanged)="onTablePageChanged($event)"
                (selectedColumnsChanged)="
                    updateSelectedColumns($event.selectedColumns)
                "
                (sortOrderChanged)="updateColumnSorting($event)"
                (itemLimitUpdated)="updateItemLimit($event)"
            >
                <ng-template
                    columnTemplate="status"
                    let-row="row"
                    let-column="column"
                >
                    <span
                        class="status-cell"
                        [ngClass]="{
                            success: row.status === 'OK',
                            warn: row.status === 'UPCOMING',
                            danger: row.status === 'EXPIRED'
                        }"
                        >{{ formatStatuses[row.status] }}</span
                    >
                </ng-template>
            </static-table>
        </div>
        <loading-indicator [isLoading]="working"></loading-indicator>
    </div>
</div>
<completed-outstanding-tasks-banner
    *ngIf="(!expiries || expiries.length === 0) && !working"
    widgetHeading="Organisation Authority Register Expiries (RPA and Personnel)"
></completed-outstanding-tasks-banner>
